/******************************************************************************
 *
 * RuntimeChecklistItem
 *
 * Enterprise Runtime Checklist Item
 *
 * NOTE:
 * UI Modernized
 * Business Logic Unchanged
 *
 ******************************************************************************/

import React, { useEffect, useState } from "react";

import ResponseControl from "./ResponseControl";

import wmsWorkService from "../../../services/wmsWorkService";

export default function RuntimeChecklistItem({

    item

}) {

    const [

        response,

        setResponse

    ] = useState("");

    const [

        remarks,

        setRemarks

    ] = useState("");

    useEffect(() => {

        setResponse(

            item?.latest_response?.response_value || ""

        );

        setRemarks(

            item?.latest_response?.remarks || ""

        );

    }, [item]);

    const [

        saving,

        setSaving

    ] = useState(false);

    async function saveResponse(
        responseValue,
        remarksValue
    ) {

        try {

            setSaving(true);

            const result =
                await wmsWorkService.saveChecklistResponse(

                    item.id,

                    {
                        response: responseValue,
                        remarks: remarksValue
                    }

                );

            console.log(
                "Response Saved",
                result
            );

        }

        catch (err) {

            console.error(
                "Failed to save response",
                err
            );

        }

        finally {

            setSaving(false);

        }

    }

    async function handleResponseChange(value) {

        setResponse(value);

        await saveResponse(
            value,
            remarks
        );

    }

    return (

        <div
            className="card border-0 shadow-sm mb-4"
            style={{
                borderRadius: "14px",
                overflow: "hidden"
            }}
        >

            {/* ==========================================================
                HEADER
            ========================================================== */}

            <div
                className="px-4 py-3 text-white"
                style={{
                    background:
                        "linear-gradient(90deg,#0d6efd,#3b82f6)"
                }}
            >

                <div className="d-flex justify-content-between align-items-start">

                    <div>

                        <div className="fw-bold fs-6">

                            #{item.sequence_no}

                            {" "}

                            {item.item_title}

                        </div>

                        {

                            item.item_description && (

                                <div
                                    className="small text-white-50 mt-1"
                                >

                                    {item.item_description}

                                </div>

                            )

                        }

                    </div>

                    <div>

                        {

                            saving ? (

                                <span className="badge bg-warning text-dark">

                                    <i className="bi bi-arrow-repeat me-1"></i>

                                    Saving...

                                </span>

                            ) : (

                                <span className="badge bg-success">

                                    <i className="bi bi-check-circle me-1"></i>

                                    Saved

                                </span>

                            )

                        }

                    </div>

                </div>

            </div>

            {/* ==========================================================
                BODY
            ========================================================== */}

            <div className="card-body">

                {/* Badge Row */}

                <div className="d-flex flex-wrap gap-2 mb-3">

                    {

                        item.section_name && (

                            <span className="badge bg-primary">

                                <i className="bi bi-grid-3x3-gap-fill me-1"></i>

                                {item.section_name}

                            </span>

                        )

                    }

                    {

                        item.mandatory ? (

                            <span className="badge bg-danger">

                                Mandatory

                            </span>

                        ) : (

                            <span className="badge bg-secondary">

                                Optional

                            </span>

                        )

                    }

                    <span className="badge bg-info text-dark">

                        {item.response_type}

                    </span>

                </div>

                {/* Description */}

                {

                    item.item_description && (

                        <div
                            className="border rounded p-3 bg-light mb-4"
                        >

                            <div
                                className="fw-semibold mb-2 text-secondary"
                            >

                                Description

                            </div>

                            <div
                                className="small text-muted"
                            >

                                {item.item_description}

                            </div>

                        </div>

                    )

                }

                {/* Response */}
                                <div className="mb-4">

                    <div className="fw-semibold mb-3">

                        <i className="bi bi-ui-checks-grid me-2"></i>

                        Response

                    </div>

                    <div
                        className="border rounded p-3"
                        style={{
                            background: "#fcfcfd"
                        }}
                    >

                        <ResponseControl

                            item={item}

                            value={response}

                            onChange={handleResponseChange}

                        />

                    </div>

                </div>

                {/* ==========================================================
                    REMARKS
                ========================================================== */}

                {

                    item.allow_remarks && (

                        <div className="mb-4">

                            <label className="form-label fw-semibold">

                                <i className="bi bi-chat-left-text me-2"></i>

                                Remarks

                            </label>

                            <textarea

                                className="form-control"

                                rows={4}

                                placeholder="Enter remarks..."

                                value={remarks}

                                onChange={async (e) => {

                                    const value = e.target.value;

                                    setRemarks(value);

                                    await saveResponse(

                                        response,

                                        value

                                    );

                                }}

                            />

                            <div className="form-text">

                                Remarks are automatically saved.

                            </div>

                        </div>

                    )

                }

                {/* ==========================================================
                    FUTURE FEATURES
                ========================================================== */}

                <div
                    className="border rounded p-3 bg-light"
                >

                    <div className="fw-semibold mb-3">

                        <i className="bi bi-tools me-2"></i>

                        Evidence & Future Features

                    </div>

                    <div className="row g-2">

                        <div className="col-lg-2 col-md-4 col-6">

                            <button

                                className="btn btn-outline-secondary w-100 d-flex flex-column justify-content-center align-items-center"

                                style={{
                                    height: "82px"
                                }}

                                disabled

                            >

                                <i className="bi bi-camera-fill fs-4 mb-2"></i>

                                <span
                                    style={{
                                        fontSize: "12px",
                                        textAlign: "center"
                                    }}
                                >
                                    Photo
                                </span>

                            </button>

                        </div>

                        <div className="col-lg-2 col-md-4 col-6">

                            <button

                                className="btn btn-outline-secondary w-100 d-flex flex-column justify-content-center align-items-center"

                                style={{
                                    height: "82px"
                                }}

                                disabled

                            >

                                <i className="bi bi-paperclip fs-4 mb-2"></i>

                                <span
                                    style={{
                                        fontSize: "12px",
                                        textAlign: "center"
                                    }}
                                >
                                    Attachment
                                </span>

                            </button>

                        </div>

                        <div className="col-lg-2 col-md-4 col-6">

                                 <button

                                    className="btn btn-outline-secondary w-100 d-flex flex-column justify-content-center align-items-center"

                                    style={{
                                        height: "82px"
                                    }}

                                    disabled

                                >

                                    <i className="bi bi-pen fs-4 mb-2"></i>

                                    <span
                                        style={{
                                            fontSize: "12px",
                                            textAlign: "center"
                                        }}
                                    >
                                        Signature
                                    </span>

                                </button>       
                        </div>

                        <div className="col-lg-2 col-md-4 col-6">

                            <button

                                className="btn btn-outline-secondary w-100 d-flex flex-column justify-content-center align-items-center"

                                style={{
                                    height: "82px"
                                }}

                                disabled

                            >

                                <i className="bi bi-qr-code-scan fs-4 mb-2"></i>

                                <span
                                    style={{
                                        fontSize: "12px",
                                        textAlign: "center"
                                    }}
                                >
                                    QR Scan
                                </span>

                            </button>                

                        </div>

                        <div className="col-lg-2 col-md-4 col-6">

                            <button

                                className="btn btn-outline-secondary w-100 d-flex flex-column justify-content-center align-items-center"

                                style={{
                                    height: "82px"
                                }}

                                disabled

                            >

                                <i className="bi bi-exclamation-triangle fs-4 mb-2"></i>

                                <span
                                    style={{
                                        fontSize: "12px",
                                        textAlign: "center"
                                    }}
                                >
                                    Observation
                                </span>

                            </button>        

                        </div>

                    </div>

                </div>

                {/* ==========================================================
                    FOOTER
                ========================================================== */}

                <div className="mt-4">
                                    <hr />

                    <div className="d-flex justify-content-between align-items-center">

                        <div className="text-muted small">

                            <i className="bi bi-info-circle me-1"></i>

                            Runtime Snapshot Execution

                        </div>

                        <div>

                            {

                                saving ? (

                                    <span className="badge bg-warning text-dark">

                                        <i className="bi bi-arrow-repeat me-1"></i>

                                        Saving...

                                    </span>

                                ) : (

                                    <span className="badge bg-success">

                                        <i className="bi bi-check-circle me-1"></i>

                                        Saved

                                    </span>

                                )

                            }

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}    
                